import { css } from '@emotion/react';
import React, { memo } from 'react';
import { fontWeight600 } from '~/css/font';
import { flex } from '~/modules/AppLayout/FlexGridCss';
import CategoryPieChart from '~/modules/tradeSheet/shared/CategoryPieChart';
import { useTradingSummaryState } from '~/modules/tradeSheet/tradingSummary/useTradingSummaryState';
import { tradeLabelCss } from '~/modules/tradeSheet/tradingSummary/tradingSummaryCss';
const TradingProporionHome = memo(function TradingProporion() {
    const { state } = useTradingSummaryState.useContainer();
    const { proportion } = state;
    return (<>
      <p css={tradeLabelCss('#00aab6')}>國內交易比重</p>
      <div css={pieChartContainerCss}>
        {proportion.home.length ? (<CategoryPieChart data={proportion.home} width={375}/>) : (<EmptyData />)}
      </div>
    </>);
});
const TradingProporionForeign = memo(function TradingProporion() {
    const { state } = useTradingSummaryState.useContainer();
    const { proportion } = state;
    return (<>
      <p css={tradeLabelCss('#00aab6')}>國外交易比重</p>
      <div css={pieChartContainerCss}>
        {proportion.foreign.length ? (<CategoryPieChart data={proportion.foreign} width={320} height={320}/>) : (<EmptyData />)}
      </div>
    </>);
});
const EmptyData = memo(function EmptyData() {
    return (<p css={css `
        ${flex.h.allCenter};
        font-size: 16px;
        ${fontWeight600};
        width: 250px;
        height: 250px;
        background-color: #cccccccc;
        border-radius: 50%;
      `}>
      無資料
    </p>);
});
const pieChartContainerCss = css `
  ${flex.h.allCenter};
  align-self: center;
  height: 320px;
  width: 100%;
  max-width: 320px;
  font-size: 16px;
  ${fontWeight600};
`;
export default { Home: TradingProporionHome, Foreign: TradingProporionForeign };
